module.exports = __webpack_public_path__ + "img/call.e63c0712.svg";